var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFollow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 6.25V2.5M10 4.375H13.75M10 13.125V12.375C10 11.3249 10 10.7999 9.79564 10.3988C9.61587 10.046 9.32904 9.75913 8.97623 9.57936C8.57515 9.375 8.0501 9.375 7 9.375H4.25C3.1999 9.375 2.67485 9.375 2.27377 9.57936C1.92096 9.75913 1.63413 10.046 1.45436 10.3988C1.25 10.7999 1.25 11.3249 1.25 12.375V13.125M7.8125 4.6875C7.8125 5.89562 6.83312 6.875 5.625 6.875C4.41688 6.875 3.4375 5.89562 3.4375 4.6875C3.4375 3.47938 4.41688 2.5 5.625 2.5C6.83312 2.5 7.8125 3.47938 7.8125 4.6875Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollow);
export default __webpack_public_path__ + "static/media/follow.f0f16393943bfd1e5910322e70936bec.svg";
export { ForwardRef as ReactComponent };